import React from "react";
import ishtiaq from "../Images/ishtiaq.jpg";
const AboutMe = () => {
  return (
    <div className="row  overflow-hidden my-5" id="About_me">
      <div className="col-md-6 main_see2 ">
        <img
          src={ishtiaq}
          alt=""
          className="svgCotnact"
          data-aos-duration="1000"
          data-aos="zoom-in-down"
        />
      </div>
      <div className="col-md-6 main_see3">
        <div
          className="about__secc"
          data-aos-duration="1000"
          data-aos="zoom-in-left"
        >
          <h1 className="About_heading">About Me</h1>
          <h1 className=" mt-4">
            Hello, I'm <span>Ishtiaq Ali</span>
          </h1>
          <p className="text-justify mt-4" style={{ fontSize: "16px" }}>
          With over three years of experience as a MERN Stack Developer — including two years at TechCreator Software — I specialize in building responsive, pixel-perfect websites with a strong focus on functionality and performance. Based in Swabi (KPK), I excel at developing dynamic user interfaces, optimizing web performance, and implementing interactive features to enhance user engagement. My expertise lies in crafting seamless, user-friendly experiences across all devices and screen sizes, while ensuring efficient and scalable frontend architectures. I work extensively with the full MERN stack — MongoDB, Express.js, React.js, and Node.js — to build robust, end-to-end web applications that are both high-performing and maintainable.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
